
import * as __star__ from '@clayui/autocomplete';

const {
default: __default__,
Autocomplete,
Item,
__esModule
} = __star__;

export {
Autocomplete,
Item,
__esModule
};
export default __default__;
